import AllProspects from "./all-prospects";
import MyProspects from "./my-prospects";
import ProspectsContainer from "./prospectsContainer";

export { AllProspects, MyProspects };

export default ProspectsContainer;
